import { styled } from '@mui/system';

const EnterNewPasswordContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '393px',
  height: '380px',
  margin: 'auto',
  backgroundColor: 'rgba(0, 0, 0, 0.54)',
  backdropFilter: 'blur(2px)',
  padding: '10px',
  [theme.breakpoints.down('sm')]: {
    height: '380px',
    width: '363px',
  },
}));

const InnerContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  border: '1px solid #AA9178',
  padding: '47px 37px 45px 28px',
});

const PageTitle = styled('div')({
  marginBottom: '29px',
  '& p': {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '25.14px',
    color: '#FFF',
    margin: '0',
  },
});

const InputContainer = styled('div')({
  width: '100%',
  height: '74px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginBottom: '14px',
});

const InputLabel = styled('div')({
  fontFamily: 'Raleway',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '16.44px',
  color: '#FFF',
});

const InputBox = styled('div')({
  border: '2px solid #AA9178',
  backgroundColor: '#FFF',
  borderRadius: '5px',
  '& input': {
    width: '100%',
    height: '100%',
    background: 'none',
    padding: '4px',
    border: '0',
    fontFamily: 'Raleway',
  },
  '& input:focus': {
    outline: 'none',
  },
});

const SubmitBtn = styled('input')({
  backgroundColor: '#AA9178',
  color: '#FFF',
  padding: '0',
  border: 'none',
  height: '22px',
  width: '63px',
  fontFamily: 'Fjalla One',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '17.6px',
});

const ErrorMessage = styled('div')({
  fontSize: '12px',
  color: 'red',
  height: '16px',
  margin: '0',
});

const ErrorMessageEmpty = styled('div')({
  height: '16px',
});

const EnterNewPassword = ({ formik }) => {
  return (
    <EnterNewPasswordContainer>
      <InnerContainer>
        <PageTitle>
          <p>Enter your new password</p>
        </PageTitle>
        <form onSubmit={formik.handleSubmit}>
          <InputContainer>
            <InputLabel>
              <label htmlFor="password">Your new password</label>
            </InputLabel>
            <InputBox>
              <input
                type="password"
                id="password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
              />
            </InputBox>
            {formik.errors.password && formik.touched.password ? (
              <ErrorMessage>Please enter 4 to 12 characters as your new password</ErrorMessage>
            ) : (
              <ErrorMessageEmpty />
            )}
          </InputContainer>
          <InputContainer>
            <InputLabel>
              <label htmlFor="confirmPassword">Confirm your new password</label>
            </InputLabel>
            <InputBox>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
              />
            </InputBox>
            {formik.errors.confirmPassword && formik.touched.confirmPassword ? (
              <ErrorMessage>Please confirm your new password</ErrorMessage>
            ) : (
              <ErrorMessageEmpty />
            )}
          </InputContainer>
          <SubmitBtn type="submit" value="Submit" />
        </form>
      </InnerContainer>
    </EnterNewPasswordContainer>
  );
};

export default EnterNewPassword;
